import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';

export class LuaModalElement extends LitElement {
  /**
   * Whether the share certificate dialog is open.
   * When set to `true`, the modal dialog is displayed.
   */
  @property({ type: Boolean, reflect: true })
  open = false;

  protected override updated(changedProps: Map<string, unknown>) {
    super.updated(changedProps);
    if (changedProps.has('open') && this.open) {
      this.showModal(this.open);
    }
  }

  protected showModal(show: boolean) {
    const modal = this.renderRoot.querySelector('luds-modal');
    show ? modal?.show(show) : modal?.close();
  }
}
